<fieldset>
    <legend class="fw:bold m-16:b">Deine Optionen:</legend>
    <div class="form-control grid-container">
        <div
            [ngClass]="{
                'g-6': compactMode,
                'g-12': !compactMode,
            }"
        >
            <input
                type="checkbox"
                id="check-copay"
                name="copay"
                [checked]="hasDeductible"
                (change)="toggleDeductible.emit(!hasDeductible)"
            />
            <label for="check-copay">Selbstbeteiligung</label>
        </div>
        <div
            [ngClass]="{
                'g-5': compactMode,
                'g-12': !compactMode,
            }"
        >
            <input
                type="checkbox"
                id="check-theft-coverage"
                name="theft-coverage"
                [checked]="hasTheftCoverage"
                (change)="toggleTheftCoverage.emit(!hasTheftCoverage)"
            />
            <label for="check-theft-coverage">Diebstahlschutz</label>
        </div>
    </div>
</fieldset>
<fieldset>
    <legend class="fw:bold m-16:b">Zahlweise</legend>
    <div class="form-control grid-container">
        <div
            [ngClass]="{
                'g-6': compactMode,
                'g-12': !compactMode,
            }"
        >
            <input
                type="radio"
                id="radio-payment-rhythm-yearly"
                name="payment-rhythm"
                value="yearly"
                [checked]="!hasMonthlySettlementPeriod"
                (change)="toggleSettlementPeriod.emit(false)"
            />
            <label for="radio-payment-rhythm-yearly">jährlich</label>
        </div>
        <div
            [ngClass]="{
                'g-5': compactMode,
                'g-12': !compactMode,
            }"
        >
            <input
                type="radio"
                id="radio-payment-rhythm-monthly"
                name="payment-rhythm"
                value="monthly"
                [checked]="hasMonthlySettlementPeriod"
                (change)="toggleSettlementPeriod.emit(true)"
            />
            <label for="radio-payment-rhythm-monthly">monatlich</label>
        </div>
    </div>
</fieldset>
@if (!compactMode) {
    <fieldset>
        <legend class="fw:bold m-16:b">Wann hast Du Dein Gerät gekauft?</legend>
        <div class="form-control grid-container">
            <div
                [ngClass]="{
                    'g-6': compactMode,
                    'g-12': !compactMode,
                }"
            >
                <input
                    type="radio"
                    id="radio-device-bought-recently"
                    name="device-recently-bought"
                    value="true"
                    [checked]="boughtInLastTwoWeeks"
                    (change)="toggleBoughtInLastTwoWeeks.emit(true)"
                />
                <label for="radio-device-bought-recently">Innerhalb der letzten 14 Tage</label>
            </div>
            <div
                [ngClass]="{
                    'g-5': compactMode,
                    'g-12': !compactMode,
                }"
            >
                <input
                    type="radio"
                    id="radio-device-bought-before"
                    name="device-recently-bought"
                    value="false"
                    [checked]="!boughtInLastTwoWeeks"
                    (change)="toggleBoughtInLastTwoWeeks.emit(false)"
                />
                <label for="radio-device-bought-before">Vorher</label>
            </div>
        </div>
    </fieldset>
}
